export const GENERATE_CODE = '@@channel/GENERATE_CODE'

export interface ChannelState {
	CODE: string;
	FILE_ID: string;
}

export interface Channel {
	CODE: string;
	FILE_ID: string;
}

interface GenerateCodeAction {
	type: typeof GENERATE_CODE;
	payload: Channel;
}

export type ChannelActionTypes = GenerateCodeAction
